import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getListasPanel = async (searchTerm, page, perPage) => {
    let queryParams = [];
    if (searchTerm) {
      queryParams.push(`lp_descripcion=${encodeURIComponent(searchTerm)}`);
    }
    if (page) {
      queryParams.push(`page=${encodeURIComponent(page)}`);
    }
    if (perPage) {
      queryParams.push(`perPage=${encodeURIComponent(perPage)}`);
    }
    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  
    return await getData("/listasPrecios", queryString);
  }


export const getListaById = async (id) => {
    const res = await getData(`/listasprecios/${id}`)
    return res
}

export const postLista = async (body) => {
    const res = await postData('/listasprecios', body)
    return res
}

export const patchLista = async (id, body) => {
    const res = await patchData(`/listasprecios/${id}`, body)
    return res
}

export const deleteLista= async (id) => {
    const res = await deleteData(`/listasprecios/${id}`)
    return res
}


